import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Box, Collapse, Divider, Typography } from "@mui/material";
import { type ReactNode, useState } from "react";

interface CollapsibleSectionProps {
  title: string | ReactNode;
  children: ReactNode;
  defaultOpen?: boolean;
  showDividers?: boolean;
}

export default function CollapsibleSection({
  title,
  children,
  defaultOpen = false,
  showDividers = true,
}: CollapsibleSectionProps) {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <Box>
      {showDividers && <Divider sx={{ mb: 2 }} />}

      <Box
        onClick={() => setOpen(!open)}
        sx={{
          display: "flex",
          gap: 1,
          alignItems: "center",
          cursor: "pointer",
          mb: 2,
        }}
      >
        <ExpandMoreIcon
          sx={{
            transform: open ? "rotate(180deg)" : "rotate(0deg)",
            transition: "transform 0.3s",
          }}
        />
        {typeof title === "string" ? (
          <Typography variant="h6" fontWeight={600}>
            {title}
          </Typography>
        ) : (
          title
        )}
      </Box>

      <Collapse in={open}>
        <Box sx={{ mb: 2 }}>{children}</Box>
      </Collapse>

      {showDividers && <Divider />}
    </Box>
  );
}
